import { Component, ViewChild, ElementRef, Output, AfterViewInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'adminapp-configure-point',
  templateUrl: './configure-point.component.html',
  styleUrls: ['./configure-point.component.scss']
})
export class ConfigurePointComponent implements AfterViewInit {

  @ViewChild('configurePointDialog') configurePointDialog: any;
  @ViewChild('assignRoleButton') assignRoleButton: any;
  pointRoleList: any;
  pointRoleSelectorDomRepeat: any;
  pointRoleSelector: any;
  pointIri: string;
  selectedPropertyRole: string;

  @Output()
  assignPropRoleEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(private elRef: ElementRef) { }

  ngAfterViewInit(): void {
    this.assignRoleButton.nativeElement.addEventListener('click', this.emitAssignRoleEvent.bind(this));
  }

  open(pointName: string, pointIri: string, pointRoles: any) {
    this.pointRoleSelectorDomRepeat = this.elRef.nativeElement.querySelector('coretex-select dom-repeat');
    this.pointRoleSelector = this.elRef.nativeElement.querySelector('coretex-select');
    this.configurePointDialog.nativeElement.titleText = 'Edit Role for Point : ' + pointName;
    this.pointRoleSelector.placeholder = pointRoles[0].label;
    this.pointRoleSelectorDomRepeat.items = pointRoles;
    this.pointIri = pointIri;
    this.pointRoleSelector.addEventListener('value-changed', this.setSelectedRole.bind(this));
    this.configurePointDialog.nativeElement.open();
  }

  setSelectedRole(event: any) {
    this.selectedPropertyRole = event.detail.value;
  }

  emitAssignRoleEvent() {
    this.assignPropRoleEmitter.emit(
      {
        role: this.selectedPropertyRole,
        point: this.pointIri
      }
    );
  }

}
